import {Component} from '@lib/Component';
import anime from 'animejs';

export class Collapse extends Component {
  isOpen = false;
  content: Component | null = null;
  contentHeight = 0;
  nestedList: HTMLDivElement[] = [];
  plus: HTMLDivElement | undefined | null = undefined;
  public trigger: Component | null = null;

  constructor() {
    super();
    this.onClickNestedItem = this.onClickNestedItem.bind(this);
  }

  getHeight() {
    const clone = this.content?.element?.cloneNode(true) as HTMLElement;
    clone &&
      (clone.style.cssText =
        'visibility: hidden; margin: -9999px 0; height: auto;');
    const height =
      this.content?.element?.parentElement?.appendChild(clone).clientHeight;
    this.content?.element?.parentElement?.removeChild(clone);
    return height;
  }

  slideUp() {
    this.element?.classList.remove('open');
    this.plus?.classList.remove('open');
    anime({
      complete: () => {
        this.isOpen = false;
      },
      duration: 300,
      easing: 'easeOutCubic',
      height: 0,
      targets: this.content?.element,
    });
  }

  slideDown() {
    this.element?.classList.add('open');
    this.plus?.classList.add('open');
    anime({
      complete: () => {
        this.isOpen = true;
      },
      duration: 300,
      easing: 'easeOutCubic',
      height: this.getHeight(),
      targets: this.content?.element,
    });
  }

  didMount() {
    const {trigger = '', content = ''} = this.element?.dataset || {};
    this.trigger = new Component();
    trigger &&
      this.trigger.mount(
        this.element?.querySelector(trigger) as HTMLDivElement,
      );
    this.content = new Component();
    content &&
      this.content.mount(
        this.element?.querySelector(content) as HTMLDivElement,
      );
    this.contentHeight = this.content?.element?.clientHeight ?? 0;

    this.trigger.on('click', (e) => {
      if (this.element?.classList.contains('open')) {
        this.slideUp();
      } else {
        this.slideDown();
      }
    });

    this.plus =
      this.trigger?.element?.querySelector('.a-plus') ||
      this.trigger?.element?.querySelector('.a-icon-plus');

    this.content.on('click', () => {
      // this.isOpen && this.slideUp();
    });

    if (this.element) {
      this.nestedList = [
        ...this.element.querySelectorAll('.js-collapse'),
      ] as HTMLDivElement[];

      this.nestedList.map((item) => {
        item.addEventListener('click', this.onClickNestedItem);
      });
      //
      // this.on('click', (event: MouseEvent) => {
      //   if (event.target !== this.trigger?.element) {
      //     console.log(this.element, event.target);
      //     anime({
      //       complete: () => {
      //         this.isOpen = true;
      //       },
      //       delay: 350,
      //       duration: 300,
      //       easing: 'easeOutCubic',
      //       height: this.getHeight(),
      //       targets: this.content?.element,
      //     });
      //   }
      // });
    }
  }

  onClickNestedItem(event: MouseEvent) {
    const currentTarget = event.currentTarget as HTMLDivElement;
    const target = event.target as HTMLAnchorElement;
    if (target.tagName !== 'A') {
      setTimeout(() => {
        if (currentTarget.classList.contains('open')) {
          anime({
            complete: () => {
              this.isOpen = true;
            },
            duration: 300,
            easing: 'easeOutCubic',
            height: this.getHeight(),
            targets: this.content?.element,
          });
        }
      }, 300);
    }
  }

  clearHandle() {
    this.trigger?.removeAllEventListeners('click');
  }

  didUnmount() {
    this.nestedList.map((item) => {
      item.removeEventListener('click', this.onClickNestedItem);
    });
  }
}
